'use strict';
import util from '../../util';
import validator from '../../validator';
import analytics from '../../analytics';

const $mainWrapper = $('#quick-shop-panel, #pdpMain');
const oosEmail = function (e) {
    e.preventDefault();
    const regexEmail = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    const $comingSoon = $('.coming-soon-container');
    if ($('#oos_email_btn_registered').length) {
        const url = util.toAbsoluteUrl($('#dwfrm_emailbackinstockregistration').attr('action'));
        const productId = $(this).parents('form').find('input#dwfrm_emailbackinstockregistration_productId').val();
        const isCommingSoon = $(".oos_email_form input.commingsoon").length > 0 ? $(".oos_email_form input.commingsoon").val() : null 

        $.ajax({
            url: util.appendParamToURL(url, 'format', 'ajax'),
            data: { pid: productId, isCommingSoon: isCommingSoon },
            method: 'POST'
        }).done((response) => {
            const $comingSoonWrapper = $('.coming-soon-wrapper_registered');
            const $oosEmailSentRegistered = $('.oos_email_sent_registered');
            const $oosNotify = $('.oos_notify');
            const $oosEmailBtnRegistered = $('#oos_email_btn_registered');
            const $oosEmailForm = $('.oos_email_form');

            $oosEmailSentRegistered.show();
            $oosNotify.hide();
            $oosEmailBtnRegistered.addClass('oos_email_btn_registered_sent');
            $oosEmailForm.find('span.error').remove();
            $oosEmailForm.find('input.email').removeClass('valid');
            $oosEmailForm.find('.form-row').removeClass('focused');
            $oosEmailForm.find('.back-in-stock-wrapper').addClass('success');
            $comingSoonWrapper.addClass('success');
            $oosEmailBtnRegistered.find('.button-text').text($oosEmailBtnRegistered.data('sent-text'));
            $('<i class="icon icon-right-tick"></i>').insertAfter($oosEmailForm.find('.button-oos .button'));
            if ($comingSoon.length) analytics.notifyMeClick(productId);
        });
    } else {
        const emailInput = $('.oos_email_form input.email');
        const emailValue = emailInput.val();
        const url = util.toAbsoluteUrl($('#dwfrm_emailbackinstockregistration').attr('action'));
        const productId = $(this).parents('form').find('input#dwfrm_emailbackinstockregistration_productId').val();
        const isCommingSoon = $(".oos_email_form input.commingsoon").length > 0 ? $(".oos_email_form input.commingsoon").val() : null 
    
        if (emailValue.length !== 0 && regexEmail.test(emailValue)) {
            $.ajax({
                url: util.appendParamToURL(url, 'format', 'ajax'),
                data: {
                    email: emailValue,
                    pid: productId,
                    isCommingSoon: isCommingSoon
                },
                method: 'POST'
            }).done((response) => {
                const $oosEmailSent = $('.oos_email_sent');
                const $oosNotify = $('.oos_notify');
                const $oosEmailForm = $('.oos_email_form');
                const $oosEmailBtn = $('#oos_email_btn');

                $oosEmailSent.show();
                $oosNotify.hide();
                $oosEmailForm.find('span.error').remove();
                $oosEmailBtn.addClass('oos_email_btn_sent');
                emailInput.removeClass('valid');
                $oosEmailForm.find('.form-row').removeClass('focused');
                $oosEmailForm.find('.back-in-stock-wrapper').addClass('success');
                $oosEmailBtn.text($oosEmailBtn.data('sent-text'));
                $('<i class="icon icon-right-tick"></i>').insertAfter($oosEmailForm.find('.button-oos .button'));
                if ($comingSoon.length) analytics.notifyMeClick(productId);
            });
        } else {
            if (!$('.oos_email_form span.error').text()) {
                oosEmailError();
            }
            return false;
        }
    }
	
}

const oosEmailError = function () {
    const $oosEmailForm = $('.oos_email_form');
    const $emailInput = $oosEmailForm.find('input.email');
    const $oosEmailBtn = $('#oos_email_btn');
    
    $('<div class="error-placement"><i class="error-icon"></i><span class="error">' + Resources.BACK_IN_STOCK_EMAIL_ERROR + '</span></div>').insertAfter($oosEmailForm.find('.form-row label'));
    $emailInput.addClass('error');
    $oosEmailForm.find('button.button-oos-email').addClass('error');
    $oosEmailBtn.prop('disabled', true);
}

const initoosEmail = () => {
    $mainWrapper.on('click', 'button#oos_email_btn, button#oos_email_btn_registered', oosEmail);

    $mainWrapper.on('focus', '.oos_email_form input.email', () => {
        if ($('form[name$="_emailbackinstockregistration"]').length) {
            validator.initForm('form[name$="_emailbackinstockregistration"]');
        }
    });
};

const animateoosEmail = () => {
    const $emailInput = $('.oos_email_form input.email');
    const $backInStockWrapper = $('.back-in-stock-wrapper');
    const $ctaWrapper = $('.cta-wrapper');
    const $animateElement = $('.back-in-stock-wrapper');

    $mainWrapper.on('focus', '.oos_email_form input.email', function() {
        const $this = $(this);
        $this.closest('.form-row').addClass('focused');
        if ($emailInput.hasClass('error')) {
            $this.closest($backInStockWrapper).addClass('error');
        } else {
            $this.closest($backInStockWrapper).removeClass('error');
        }
    });

    $mainWrapper.on('blur', '.oos_email_form input.email', function() {
        const $this = $(this);
        if (!$this.val()) {
            $this.closest('.form-row').removeClass('focused');
        }
        if ($emailInput.hasClass('error')) {
            $this.closest($backInStockWrapper).addClass('error');
        } else {
            $this.closest($backInStockWrapper).removeClass('error');
        }
    });

    $mainWrapper.on('click', '.btn-out-of-stock', () => {
        if ($ctaWrapper.length && $animateElement.length) {
            $ctaWrapper.find('.product-add-to-cart, .add-to-cart-out-of-stock').hide();
            $ctaWrapper.find('.btn-favourite').hide();
            $animateElement.animate({ 'top': '0', 'opacity': '1', 'z-index': '1' }, 'slow');
            $animateElement.css('position', 'relative');
            $animateElement.addClass('animate-fade-in');
            $ctaWrapper.find('.oos-notify-top').show();
            $ctaWrapper.find('.oos-bottom-text').hide();
        }
    });
};

function comingSoonCTA() {
    const $comingSoon = $('.coming-soon-notify');
    const $btn = $('.add-to-cart-out-of-stock .btn-out-of-stock');

    if ($comingSoon.length && $btn.length) {
        $btn.find('.button-text').text($btn.data('cmg-soon-text'));
    }
}

export default {
    init: function () {
        initoosEmail();
        animateoosEmail();
        comingSoonCTA();
    }
};
